import overapi from "../../../../assets/img/programming/overapi.webp";
import php from "../../../../assets/img/programming/php.webp";
import w3schools from "../../../../assets/img/programming/w3schools.webp";
import devhints from "../../../../assets/img/programming/devhints.webp";
import cheatography from "../../../../assets/img/programming/cheatography.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";

export const DataDoc = [
  {
    title: "OverAPI",
    path: "https://overapi.com/php",
    icon: overapi,
    cName: "icon",
    description: "Collecting All Cheat Sheets. Big cheatsheets ressources.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "Php Cheatsheet",
    path: "https://phpcheatsheets.com/",
    icon: php,
    cName: "icon",
    description: "A simple website with some php cheatsheets. ",
  },
  {
    title: "Devhints",
    path: "https://devhints.io/wip/php",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "W3schools",
    path: "https://www.w3schools.com/php/default.asp",
    icon: w3schools,
    cName: "icon",
    description:
      "W3Schools is an educational website for learning web technologies online. Content includes tutorials and references.",
  },
  {
    title: "Php (Official)",
    path: "https://www.php.net/docs.php",
    icon: php,
    cName: "icon",
    description: "The Official php documentation.",
  },
  {
    title: "Cheatography",
    path: "https://cheatography.com/tag/php/",
    icon: cheatography,
    cName: "icon",
    description:
      "Over 3,500 Free Cheat Sheets, Revision Aids and Quick References. You can create yours.",
  },
];
